import { render, staticRenderFns } from "./AddressItemSimpleCard.vue?vue&type=template&id=d68b4d7c&scoped=true"
import script from "./AddressItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./AddressItemSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./AddressItemSimpleCard.vue?vue&type=style&index=0&id=d68b4d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68b4d7c",
  null
  
)

export default component.exports